import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

import { computed, PropType, watch } from 'vue';
import uniq from 'lodash-es/uniq';
import * as helper from '@/lib/helpers/slider.helpers';
import { BaseSlider } from '@/lib/components/Slider';
import { ColorName } from '@/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'SlicesSlider',
  props: {
  modelValue: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 0
  },
  enableShortcuts: {
    type: Boolean,
    default: true
  },
  color: {
    type: String as PropType<ColorName>,
    default: 'primary-500'
  },
  annotated: {
    type: Array as PropType<number[]>,
    default: () => []
  },
  size: {
    type: String,
    default: 'regular',
    validator: (value: string) => ['small', 'regular'].includes(value)
  }
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const uniqAnnotated = computed<number[]>(() => uniq(props.annotated));

watch(() => props.annotated, () => {
  if (isInvalid(props.annotated)) {
    throw new Error('The array should only contains numbers.');
  }
});

const isInvalid = (annotated: Array<number>) => annotated.filter((el) => isNaN(+el) || !el.toString().length).length;
const getPercent = (value: number) => helper.getPercent(value, 0, props.max);
const onInput = (value: number) => {
  emit('update:modelValue', value);
  emit('change', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_unref(BaseSlider), {
      class: "h-full",
      max: __props.max,
      min: 0,
      step: 1,
      "model-value": __props.modelValue,
      color: __props.color,
      size: __props.size,
      "enable-shortcuts": __props.enableShortcuts,
      vertical: "",
      dark: "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onInput($event)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqAnnotated.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            style: _normalizeStyle('transform: translateY(-' + (100 - getPercent(item)) + '%)'),
            class: _normalizeClass(["absolute h-full text-gray-500", __props.size === 'small' ? 'ml-3' : 'ml-6'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["absolute bg-white rounded-full", __props.size === 'small' ? 'h-px w-px' : 'h-1 w-1']),
              style: _normalizeStyle(__props.size === 'small' ? 'bottom: -2px;' : 'bottom: -5px;')
            }, null, 6)
          ], 6))
        }), 128))
      ]),
      _: 1
    }, 8, ["max", "model-value", "color", "size", "enable-shortcuts"])
  ], 32))
}
}

})